"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiquidiseService = void 0;
const LiquidiseServiceLive_1 = require("./LiquidiseServiceLive");
class LiquidiseService {
    static create() {
        return new LiquidiseServiceLive_1.LiquidiseServiceLive();
    }
}
exports.LiquidiseService = LiquidiseService;
//# sourceMappingURL=LiquidiseService.js.map